import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import LoginReducer from "./auth/login/reducer";
import OtpReducer from "./auth/otp/reducer";
import ProfileReducer from "./auth/profile/reducer";
import AccountReducer from "./auth/register/reducer";

// Departments
import DepartmentsReducer from "./departments/department.slice";

// Tenant Roles
import TenantRolesReducer from "./tenantRoles/tenantRole.slice";

// Tenant Rental Config
import TenantRentalConfigReducer from "./tenantRentalConfig/tenantRentalConfig.slice";

// Client Rental Config
import ClientRentalConfigReducer from "./clientRentalConfig/reducer";

// Meetings
import MeetingsReducer from "./meetings/reducer";

// Leads
import LeadsReducer from "./leads/lead.slice";

// Lead Attachments
import LeadAttachmentsReducer from "./leadAttachments/leadAttachment.slice";

// Countries
import CountriesReducer from "./countries/country.slice";

// Clients
import ClientsReducer from "./clients/client.slice";

// Suppliers
import SuppliersReducer from "./suppliers/supplier.slice";

// Client Contacts
import ClientContactsReducer from "./clientContacts/clientContact.slice";

// Client Sites
import ClientSitesReducer from "./clientSites/clientSite.slice";

// Client Site Attachments
import ClientSiteAttachmentsReducer from "./clientSiteAttachments/clientSiteAttachment.slice";

// Tenant Locations
import TenantLocationsReducer from "./tenantLocations/tenantLocation.slice";

// Site Types
import SiteTypesReducer from "./siteTypes/siteType.slice";

// User Profiles
import UserProfilesReducer from "./userProfiles/profile.slice";

// Roles
import RolesReducer from "./roles/role.slice";

// Global Users
import GlobalUsersReducer from "./globalUsers/globalUser.slice";

// Client Meetings
import ClientMeetingsReducer from "./clientMeetings/clientMeeting.slice";

// Notifications
import NotificationReducer from "./notifications/notificationSlice";

// Products
import ProductsReducer from "./products/product.slice";

// Stock Items
import StockItemsReducer from "./stockItems/stockItem.slice";

// Purchase Orders
import PurchaseOrdersReducer from "./purchaseOrders/purchaseOrder.slice";

// Quotes
import QuotesReducer from "./quotes/quote.slice";

// Tenant Labour Rates
import TenantLabourRatesReducer from "./tenantLabourRates/tenantLabourRate.slice";

// Assets
import AssetsReducer from "./assets/asset.slice";

// Work Orders
import WorkOrdersReducer from "./workOrders/workOrder.slice";

// Work Order Attachments
import WorkOrderAttachmentsReducer from "./workOrderAttachments/workOrderAttachment.slice";

// Projects
import ProjectsReducer from "./projects/project.slice";

// Jobs
import JobsReducer from "./jobs/job.slice";

// Dashboard
import DashboardReducer from "./dashboard/dashboard.slice";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Otp: OtpReducer,
  Departments: DepartmentsReducer,
  TenantRoles: TenantRolesReducer,
  TenantRentalConfig: TenantRentalConfigReducer,
  ClientRentalConfig: ClientRentalConfigReducer,
  Meetings: MeetingsReducer,
  Leads: LeadsReducer,
  LeadAttachments: LeadAttachmentsReducer,
  Countries: CountriesReducer,
  Clients: ClientsReducer,
  Suppliers: SuppliersReducer,
  ClientContacts: ClientContactsReducer,
  ClientSites: ClientSitesReducer,
  ClientSiteAttachments: ClientSiteAttachmentsReducer,
  TenantLocations: TenantLocationsReducer,
  SiteTypes: SiteTypesReducer,
  UserProfiles: UserProfilesReducer,
  Roles: RolesReducer,
  GlobalUsers: GlobalUsersReducer,
  ClientMeetings: ClientMeetingsReducer,
  Notifications: NotificationReducer,
  Products: ProductsReducer,
  StockItems: StockItemsReducer,
  PurchaseOrders: PurchaseOrdersReducer,
  Quotes: QuotesReducer,
  TenantLabourRates: TenantLabourRatesReducer,
  Assets: AssetsReducer,
  WorkOrders: WorkOrdersReducer,
  WorkOrderAttachments: WorkOrderAttachmentsReducer,
  Projects: ProjectsReducer,
  Jobs: JobsReducer,
  dashboard: DashboardReducer,
});

export default rootReducer;
